var _path, _rect, _rect2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 632,
    viewBox: "0 0 551 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.085 366.453C525.085 498.482 413.972 606.999 275.042 606.999C136.113 606.999 25 498.482 25 366.453C25 234.423 136.113 125.906 275.042 125.906C413.972 125.906 525.085 234.423 525.085 366.453Z",
    stroke: "#F6D365",
    strokeWidth: 50
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.017,
    width: 330.051,
    height: 63.7312,
    rx: 31.8656,
    fill: "#F6D365"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 242.037,
    y: 26.5586,
    width: 66.0102,
    height: 100.908,
    fill: "#F6D365"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 274,
    y1: 372,
    x2: 274,
    y2: 177,
    stroke: "black",
    strokeWidth: 30,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeUp);
export default __webpack_public_path__ + "static/media/time_up.0d140da4cb707c288cb26b49306ba531.svg";
export { ForwardRef as ReactComponent };